/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/ProtocolTable
 * @desc Renders an ProtocolTable node
 */

import { TableItemContainer as TableItem } from 'labstep-web/components/Table/Item';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolTable } from 'labstep-web/models/protocol-table.model';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import { useReactNodeView } from 'labstep-web/prosemirror/components/ReactNodeView';
import React from 'react';
import type { IComponentProps } from './types';

export class ProtocolTableNode extends React.Component<IComponentProps> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { id, timestamp, entity } = this.props;
    const { entityName } = ProtocolTable;
    const readProps = {
      entityName,
      id,
      timestamp,
    };

    return (
      <div contentEditable={false}>
        <Read {...readProps}>
          {({ entity: protocolTable }) => (
            <TableItem
              readOnly={!!timestamp}
              table={protocolTable as ProtocolTable}
              allowLocking={
                entity.entityName === Protocol.entityName ||
                entity.isTemplate
              }
            />
          )}
        </Read>
      </div>
    );
  }
}

export const ProtocolTableNodeView = ({ entity, timestamp }: any) => {
  const context = useReactNodeView();
  const { guid } = (context.node as any).attrs;

  return (
    <ProtocolTableNode
      id={guid}
      entity={entity}
      // readOnly={!context.view.editable}
      timestamp={timestamp}
    />
  );
};
